import { SportingSecureParams } from 'services/sporting/types';
import { getSportingServiceURL } from 'services/sporting/utils/getSportingURL';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';
import { appendFormDataWithObjectValues } from 'utils/appendFormDataWithObjectValues';
import { customFetch } from 'utils/customFetch';
import { UnexpectedError } from 'utils/errors';

type Payload = {
  lastName: string;
  firstName: string;
  phoneNumber: string;
};

export const changePersonalDataForCurrentUser = async (
  params: SportingSecureParams<Payload>
): Promise<void> => {
  const { payload } = params;

  const endpointURL = getSportingServiceURL('changePersonalData');

  const headers = createSportingHeaders();

  const body = new FormData();
  appendFormDataWithObjectValues(body, payload);

  const response = await customFetch(endpointURL, {
    method: 'POST',
    headers,
    body
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }
};
